import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
  REQUEST,
  fetchSuccess,
  fetchFailure,
  marketplaceConflict,
  clearMarketplaceConflict,
} from '../../actions/signals/delete';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';

function* process(action) {
  const { signal_type, force } = action.payload;
  // Always start a new request from a clean conflict slot - prevents
  // the cascade dialog from popping back open after the user has
  // already chosen "delist & delete" or cancelled.
  yield put(clearMarketplaceConflict());
  try {
    const userHeaders = getLocalUser();
    const url =
      `${config.API_URL}/signal?signal_type=${encodeURIComponent(signal_type)}`
      + (force ? '&force=true' : '');
    const response = yield call(axios.delete, url, { headers: { ...userHeaders } });

    yield put(fetchSuccess({ response: signal_type }));
    yield put({
      type: 'SHOW_SUCCESS_SNACKBAR',
      message: `Signal Type ${signal_type} Deleted (Count: ${response.data.status})`,
    });
  } catch (error) {
    const status = error?.response?.status;
    // BE wraps every responseJSON payload as ``{ data: <payload> }``
    // (see core/src/utils/api_utils.py::responseJSON). Tolerate both
    // shapes so we don't have to remember the convention at every
    // call site - and so the saga still works if a future endpoint
    // returns the raw payload directly.
    const raw = error?.response?.data || {};
    const body = raw?.data && typeof raw.data === 'object' ? raw.data : raw;
    // Canonical envelope: {error: {code, message, details}}; tolerate the
    // older flat-string form as well.
    const errCode = typeof body?.error === 'object' ? body.error?.code : body?.error;
    const errMessage =
      (typeof body?.error === 'object' && body.error?.message) || body?.message;

    // 409 marketplace conflict is an interactive state, not a real
    // error. Two flavors:
    //   - active_marketplace_subscribers: severe, cancels paying subs
    //   - published_marketplace_listing : advisory, just delists
    // Both surface listings + sub summary so the cascade dialog
    // can render the right copy.
    const isMarketplaceConflict =
      status === 409 && (
        errCode === 'active_marketplace_subscribers'
        || errCode === 'published_marketplace_listing'
      );
    if (isMarketplaceConflict) {
      yield put(marketplaceConflict({
        signal_type,
        kind:               errCode,
        message:            errMessage,
        active_subscribers: body.active_subscribers,
        listings:           body.listings || [],
      }));
      yield put(fetchFailure({ error: signal_type, conflict: true }));
      return;
    }

    yield put(Error(error));
    yield put(fetchFailure({ error: signal_type }));
    yield put({
      type: 'SHOW_ERROR_SNACKBAR',
      message: `Could not Delete Signal Type ${signal_type}`,
    });
  }
}

export function* watch() {
  yield takeEvery(REQUEST, process);
}
